export default "__VITE_ASSET__bcVeNeJZ__"